/**
 * Конфигурация API
 * Использует переменные окружения из .env файлов
 */
export const API_BASE_URL: string =
  import.meta.env.VITE_API_URL || 'https://osagotop.ru';
export const PUBLIC_API_BASE_URL: string =
  import.meta.env.VITE_PUBLIC_API_URL || 'https://api.osagotop.ru/api';
/**
 * DEV-101: сервис авторизации osago-accounts. Пусто - значит контур ещё на старой
 * сессии: транспорт не добавит Bearer, вход пойдёт прежним путём.
 */
export const ACCOUNTS_API_URL: string = import.meta.env.VITE_ACCOUNTS_API_URL || '';
export const DOMAIN_NAME: string =
  import.meta.env.VITE_DOMAIN_NAME || 'OsagoTop';
export const CLIENT_URL: string =
  import.meta.env.VITE_CLIENT_URL || 'https://osagotop.ru';
